// @flow
import * as React from 'react';
import { TextInput } from '@coverright/ui/inputs';
import { Autocomplete } from '@mui/material';

type Props = {
  parentCompanies: string[];
  onChange: (val: string) => void;
};
export const ParentCompanyFilter = ({parentCompanies, onChange}: Props) => {

  return (
    <Autocomplete options={parentCompanies}
                  onChange={(event, value) => {
                    onChange(value as string);
                  }}
                  clearOnBlur
                  renderInput={(params) => <TextInput
                    hideTick
                    className={'mt-0'}
                    placeholder={'Parent company'}
                    {...params}
                  />} />
  );
};
